export default class CardSaveError extends Error {
  static errorType = 'CardSaveError';

  constructor(message) {
    super(message);
    this.name = CardSaveError.errorType;
  }
}
